<template>
  <crud-editor
    ref="editor"
    :is-edit="isEdit"
    :definition="definition"
    :fetch-by-id="fetchById"
    :disabled="hasNoEditPermission"
    :save="saveData"
    :return-to="returnTo"
    :item-type="entity"
    :page-loading="loading"
    :get-layout="layout"
    :show-save-and-close-button="true"
    :show-save-and-next-button="false"
    :show-save-button="true"
    :show-delete-button="false"
    :form-has-changed="formHasChanged"
    :inject-form-values="injectFormValues"
    @childValue="handleChildValue"
  >
    <template slot="page-buttons" slot-scope="scope">
      <select-printer-client-dialog
        :dialog-visible.sync="printDialogVisible"
        :on-select="printerClientSelected"
        :on-cancel="printerClientSelectionCancelled"
      />
      <base-button
        :loading="scope.loading || loading"
        :icon-only="false"
        type="primary"
        :caption="$t(`orderLine.createReturnOrder`)"
        @click="createReturnOrderLine"
      />
      <base-button
        v-if="orderIsPrintable"
        :loading="scope.loading"
        type="primary"
        icon="el-icon-printer"
        :caption="$t(`orderLine.printProductionTicket`)"
        @click="selectPrinterClient"
      />
    </template>
  </crud-editor>
</template>

<script>
import { ConvertMillimetersToCentimeters } from '@/utils/converters';
import CrudEditor from '@/components/crud/TabbedEditor';
import formMixin from './form-mixin';
import { hasEditPermissionForCode } from '@/utils/permission';
import { getEditLayoutDefinition } from './form.js';
import BaseButton from '@/components/crud/BaseButton';
import SelectPrinterClientDialog from '@/pages/components/SelectPrinterClientDialog';

export default {
  components: {
    CrudEditor,
    BaseButton,
    SelectPrinterClientDialog
  },
  mixins: [formMixin],
  data: () => ({
    isEdit: true,
    layout: getEditLayoutDefinition
  }),
  computed: {
    hasNoEditPermission() {
      return !hasEditPermissionForCode('Order', this.$store.getters.permissions);
    },
    loading() {
      return this.$store.getters[this.entityStore + '/isLoading'];
    }
  },
  methods: {
    fetchById(id) {
      return this.$store
        .dispatch(this.entityStore + '/getItem', { selector: { id } })
        .then(item => this.createFormDataFromItem(this, item));
    },
    saveData(form) {
      if (
        form.returnOrderLineYN &&
        form.deliverAtHomeYN &&
        (!form.consumerAddress || !form.consumerAddress.countryID)
      ) {
        this.$store.dispatch('notify/error', { message: this.$i18n.t('validation.countryRequiredForDelivery') });
        return;
      }
      const item = this.createItemFromFormData(this, form);
      this.$store.dispatch(this.entityStore + '/persistItem', item).then(item => {
        form.status = item.status;
        form.orderLineStatusID = item.orderLineStatusID;
        form.estimatedDeliveryDate = item.estimatedDeliveryDate;
        form.actualDeliveryDate = item.actualDeliveryDate;
        form.validationMessage = item.validationMessage;

        form.numberOfPanels = item.numberOfPanels;
        form.numberOfPanelsLeft = item.numberOfPanelsLeft;
        form.numberOfPanelsRight = item.numberOfPanelsRight;
        form.cutSizeLeft = ConvertMillimetersToCentimeters(item.cutSizeLeftInMm);
        form.cutSizeRight = ConvertMillimetersToCentimeters(item.cutSizeRightInMm);
        form.requiredFabric = ConvertMillimetersToCentimeters(item.requiredFabricInMm);

        form.numberOfPanelsLining = item.numberOfPanels;
        form.numberOfPanelsLeftLining = item.numberOfPanelsLeft;
        form.numberOfPanelsRightLining = item.numberOfPanelsRight;
        form.cutSizeLeftLining = ConvertMillimetersToCentimeters(item.cutSizeLeftLiningInMm);
        form.cutSizeRightLining = ConvertMillimetersToCentimeters(item.cutSizeRightLiningInMm);
        form.requiredLiningFabric = ConvertMillimetersToCentimeters(item.requiredLiningFabricInMm);
      });
    }
  }
};
</script>
